(() => {
  function initKachingLensSync() {
    const bundleBlock = document.querySelector("kaching-bundles-block");
 
    if (!bundleBlock) {
      setTimeout(initKachingLensSync, 500);
      return;
    }
 
    function syncBundle(bundleBar) {
      const lensLink = bundleBar.querySelector(
        'a[href*="/products/lens-protector-iphone-17-pro-promax"]'
      );
 
      if (!lensLink) return;
 
      const lensProduct = lensLink.closest(
        ".kaching-bundles__bundle-products__product"
      );
 
      if (!lensProduct) return;
 
      const products = [
        ...bundleBar.querySelectorAll(
          ".kaching-bundles__bundle-products__product"
        )
      ];
 
      const caseProduct = products.find(
        product =>
          product !== lensProduct &&
          product.querySelector('select[data-name="Phone"]')
      );
 
      const caseSelect = caseProduct?.querySelector(
        'select[data-name="Phone"]'
      );
 
      const lensSelect = lensProduct.querySelector(
        'select[data-name="Phone"]'
      );
 
      if (!caseSelect || !lensSelect) return;
 
      const caseModel =
        caseSelect.options[caseSelect.selectedIndex]?.text.trim();
 
      if (!caseModel) return;
 
      const matchingLensOption = [...lensSelect.options].find(
        option => option.text.trim() === caseModel
      );
 
      if (!matchingLensOption) return;
 
      if (lensSelect.value === matchingLensOption.value) return;
 
      lensSelect.value = matchingLensOption.value;
 
      lensSelect.dispatchEvent(
        new Event("change", { bubbles: true })
      );
    }
 
    function syncAllBundles() {
      const bundleBars = bundleBlock.querySelectorAll(
        ".kaching-bundles__bar"
      );
 
      bundleBars.forEach(syncBundle);
    }
 
    function scheduleSync() {
      setTimeout(syncAllBundles, 0);
      setTimeout(syncAllBundles, 50);
      setTimeout(syncAllBundles, 150);
      setTimeout(syncAllBundles, 400);
    }
 
    bundleBlock.addEventListener("change", scheduleSync);
 
    bundleBlock.addEventListener("click", scheduleSync);
 
    bundleBlock.addEventListener("variant-selected", scheduleSync);
 
    const observer = new MutationObserver(() => {
      setTimeout(syncAllBundles, 50);
    });
 
    observer.observe(bundleBlock, {
      childList: true,
      subtree: true
    });
 
    scheduleSync();
  }
 
  initKachingLensSync();
})();